import { Model } from "@/models/base/model";

export class Author extends Model {
  constructor(params: any = {}) {
    super(params);
  }

  // 提供者一覧取得
  async getAuthors(cond: any): Promise<any> {
    const params = new URLSearchParams();

    if (cond.posterIds && cond.posterIds.length > 0) {
      params.append("posterIds", cond.posterIds.join(","));
    }

    const queryString = params.toString() ? "?" + params.toString() : "";
    this.url = `/cms/api/authors/list${queryString}`;
    return await super.fetch();
  }

  // フォロー登録取得
  async getUserAuthorFollows(): Promise<any> {
    this.url = `/cms/api/users/author-follows/list`;
    return await super.fetch();
  }

  // フォロー登録更新
  async updateUserAuthorFollows(posterId: number): Promise<any> {
    this.url = "/cms/api/users/author-follows/update";
    return await this.save({ posterId }, "POST");
  }
}
